import { baseApi } from './baseApi';

export interface Notification {
  id: string;
  type: string;
  subject: string;
  body: string;
  isRead: boolean;
  metadata?: Record<string, unknown>;
  createdAt: string;
}

/**
 * Eine Einstellung je Art der Benachrichtigung.
 *
 * So antwortet der Dienst: eine Liste von Zeilen, je Kategorie eine. Hier
 * stand einmal ein Objekt mit `categories` und den Feldern `email`/`inApp` —
 * eine Form, die nirgends entsteht. Wer sie gelesen hätte, hätte eine leere
 * Maske bekommen und beim Speichern nichts geändert.
 */
export interface NotificationPreference {
  id: string;
  category: string;
  emailEnabled: boolean;
  inAppEnabled: boolean;
}

/** Eine Kategorie ändern — der Dienst nimmt genau eine je Aufruf entgegen. */
export interface NotificationPreferenceUpdate {
  category: string;
  emailEnabled?: boolean;
  inAppEnabled?: boolean;
}

export const notificationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<{ data: Notification[]; total: number; unreadCount: number }, { page?: number; limit?: number; isRead?: boolean }>({
      query: (params) => ({
        url: '/notifications',
        params,
      }),
      providesTags: ['Notifications'],
    }),
    markAsRead: builder.mutation<void, string>({
      query: (id) => ({
        url: `/notifications/${id}/read`,
        method: 'POST',
      }),
      invalidatesTags: ['Notifications'],
    }),
    markAllAsRead: builder.mutation<void, void>({
      query: () => ({
        url: '/notifications/read-all',
        method: 'POST',
      }),
      invalidatesTags: ['Notifications'],
    }),
    getNotificationPreferences: builder.query<NotificationPreference[], void>({
      query: () => '/notifications/preferences',
      providesTags: ['Notifications'],
    }),
    updateNotificationPreferences: builder.mutation<
      NotificationPreference,
      NotificationPreferenceUpdate
    >({
      query: (body) => ({
        url: '/notifications/preferences',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Notifications'],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
  useGetNotificationPreferencesQuery,
  useUpdateNotificationPreferencesMutation,
} = notificationsApi;
